export default "__VITE_ASSET__B96pU4JS__"